import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom"
import { compressImage, convertFilesFromHEICtoJPEG, myAxios } from "src/components/common/functions";
import { useUploadImageStore } from "../main/imageStore";

export async function postsLoader({ request }: LoaderFunctionArgs) {
  const controller = new AbortController();
  request.signal.addEventListener("abort", () => {
    controller.abort();
  });
  const res = await myAxios({
    fileName: "community/readPosts.php",
    signal: controller.signal,
  });
  if (!res) throw redirect("..");
  return res.data;
}

export async function postLoader({ params, request }: LoaderFunctionArgs) {
  const { id } = params;
  const controller = new AbortController();
  request.signal.addEventListener("abort", () => {
    controller.abort();
  });
  const formData = new FormData();
  formData.append("id", id ?? "");
  const res = await myAxios({
    fileName: "community/readPost.php",
    formData,
    signal: controller.signal,
  });
  if (!res) throw redirect("..");
  const post = res.data;
  if (post === "") {
    throw redirect("..");
  }
  return post;
}

export async function postAction({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const url = String(formData.get("url") ?? "");
  const originalPhotoIds = parseJsonStringArray(formData.get("originalPhotoIds"));
  const currentPhotoIds = parseJsonStringArray(formData.get("currentPhotoIds"));
  const selectedImages = useUploadImageStore.getState().images;
  const res = await myAxios({
    fileName: url,
    formData,
  });
  if (!res) return null;
  const isMainPost = !formData.get("parentId");
  if (isMainPost) {
    const postId =
      String(res.data?.id ?? "") ||
      String(formData.get("id") ?? "");
    if (postId) {
      const removedPhotoIds = originalPhotoIds.filter(id => !currentPhotoIds.includes(id));
      if (removedPhotoIds.length) {
        const deleteFormData = new FormData();
        deleteFormData.append("sqlTable", "posts");
        deleteFormData.append("idLabel", "id");
        deleteFormData.append("filesKey", "photos");
        deleteFormData.append("id", postId);
        removedPhotoIds.forEach(fileId => deleteFormData.append("fileId", fileId));
        const deleteRes = await myAxios({
          fileName: "common/deleteAttachment.php",
          formData: deleteFormData,
        });
        if (!deleteRes) return null;
      }
      if (selectedImages.length) {
        const uploadFormData = new FormData();
        uploadFormData.append("sqlTable", "posts");
        uploadFormData.append("idLabel", "id");
        uploadFormData.append("filesKey", "photos");
        uploadFormData.append("id", postId);
        const normalizedFiles = await convertFilesFromHEICtoJPEG(selectedImages.map(image => image.file));
        for (const file of normalizedFiles) {
          uploadFormData.append("files[]", await compressImage(file));
        }
        const uploadRes = await myAxios({
          fileName: "common/createAttachment.php",
          formData: uploadFormData,
        });
        if (!uploadRes) return null;
      }
    }
  }
  useUploadImageStore.getState().reset();
  return redirect(".."); 
}

function parseJsonStringArray(value: FormDataEntryValue | null) {
  if (typeof value !== "string" || !value) return [] as string[];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}
